import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
    container: {
        marginTop: 60,
        backgroundColor: '#2C2C2E',
        height: 260,
        width: '100%',
        borderBottomRightRadius: 110
    },
    iconsHeader: {
        zIndex: 100,        
        position: 'absolute',
        left: 25,
        top: 25
    },
    content: {
        padding: 25,
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    contentDataUser: {
        justifyContent: 'flex-start',
        alignItems: 'center',
        flex: 1
    },
    textNameUser: {
        textAlign: 'center',
        color: '#fff',
        fontSize: 18,
        flexDirection: 'row',
        lineHeight: 20,
        marginTop: 20,
        justifyContent: 'space-between'
    },
    imgProfile: {
        width: 60,
        height: 60,
        borderRadius: 50
    },
    borderProfile: {
        width: 68,
        padding: 4,
        marginTop: 20,
        borderRadius: 35,
        justifyContent: 'center'
    },
    textBalanceUser: {
        textAlign: 'center',
        color: '#fff',
        fontSize: 12,
        lineHeight: 23
    },
    textExtractUser: {
        textAlign: 'center',
        color: '#fff',
        fontSize: 11,
        lineHeight: 17
    },
    textBold: {
        fontWeight: 'bold'
    },
    iconsEyeBalance: {
        marginLeft: 10
    },
    hrLine: {
        height: 0.5,
        width: '60%',
        position: 'relative',
        borderWidth: 0.5,
        marginTop: 10,
        marginBottom: 10,
        borderColor: "#8E8E93",
    }
});

export default styles;
